export default "/images/vendor/flag-icons/flags/1x1/cd.svg?b98f3e296e3b1eb74608ee24abb10f77";